import { styled } from '@mui/material/styles';

export const DivStyled = styled('div', {
  name: 'DivStyled',
})(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
